import { defineRouting } from "next-intl/routing";
 
export const routing = defineRouting({
  locales: ["en", "es"],
  defaultLocale: "es",
  localePrefix: "as-needed",
  localeDetection: false,
});

export type Locale = typeof routing.locales[number];
